import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { accountsApiRef } from '../accounts/accountsApi';

function appHref(baseUrl: string, path: string): string {
  const base = baseUrl.replace(/\/$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}

/**
 * Redirects users with must_change_password to /change-password until they update it.
 * Builds the absolute URL from app.baseUrl so dedicated-host and subpath deploys both work.
 */
export const PasswordChangeGate = (props: { children: ReactNode }) => {
  const accountsApi = useApi(accountsApiRef);
  const configApi = useApi(configApiRef);
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const path = location.pathname;
    const baseUrl = configApi.getString('app.baseUrl');
    const basePath = new URL(baseUrl).pathname.replace(/\/$/, '') || '';

    const onChangePasswordRoute =
      path === '/change-password' ||
      path === `${basePath}/change-password` ||
      path.endsWith('/change-password');

    const run = async () => {
      if (onChangePasswordRoute) {
        if (!cancelled) {
          setReady(true);
        }
        return;
      }

      try {
        const me = await accountsApi.me();
        if (cancelled) {
          return;
        }
        if (me.mustChangePassword) {
          window.location.replace(appHref(baseUrl, '/change-password'));
          return;
        }
        setReady(true);
      } catch {
        // Fail closed: a broken /me must not unlock vault routes.
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [accountsApi, configApi, location.pathname]);

  if (!ready) {
    return null;
  }
  return <>{props.children}</>;
};
